import { render, staticRenderFns } from "./ConfigLegislacoes.vue?vue&type=template&id=9474a46a&scoped=true&lang=pug&"
import script from "./ConfigLegislacoes.vue?vue&type=script&lang=js&"
export * from "./ConfigLegislacoes.vue?vue&type=script&lang=js&"
import style0 from "./ConfigLegislacoes.vue?vue&type=style&index=0&id=9474a46a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9474a46a",
  null
  
)

export default component.exports